import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
// import Token from "../../../../assets/images/platinum_token.png";
import Powerup from "../../../../assets/svgs/powerup_cube.svg";
import Warriors from "../../../../assets/images/warriors_team.png";
import { GAME_STATUS, getCurrentGameStatus } from "./viewGames.data";
import { formatDateTimeSeparately, formatDateTimeSeparatelyInCDT } from "../../../../lib/utils/dateAndTimeFormatting";
import { viewGameStyles as styles } from "./viewGames.tailwind";
import routeConstant from "../../../../lib/constants/routeConstant";
import { MAX_PLAYERS_PER_TEAM } from "../../../../lib/constants/globalConstant";
import { Chip } from "@mui/material";
import { MoreVert } from "@mui/icons-material";
import Button from "../../../shared/Button/Button";
import ViewMatchPopover from "../../../shared/Popover/ViewMatchPopover/ViewMatchPopover";
import { restartLiveGame } from "../../../../redux/slices/liveGameSlice";
import { connect } from "react-redux";

const MatchRow = ({ game, seasonId, restartGame }) => {  
  const navigate = useNavigate();
  const showMoreButton = game?.enableScorePage || (game?.apiGameId && (game?.isGameEnded || game?.isDemo));
  const { formattedDate, formattedTime } = formatDateTimeSeparatelyInCDT(game.matchStartDatetime);

  const [isLoading, setIsLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleLiveGame = () => {
    navigate(`${routeConstant.LIVE_GAME_PAGE}/${game._id}`);
  };

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget); // Toggle the popover visibility
  };

  const handleClose = () => {
    setAnchorEl(null); // to close the popover
  };

  const handlePowerUp = () => {
    navigate(routeConstant.DEPLOY_TOKEN_PAGE, {
      state: { matchId: game._id },
    });
  }

  const handleScoreGame = () => {
    const _homeTeamPlayers = game?.homeTeamPlayers?.filter(team => team?.isCurrentlyPlaying);
    const _awayTeamPlayers = game?.awayTeamPlayers?.filter(team => team?.isCurrentlyPlaying);

    let showRoster = false;

    if ((_homeTeamPlayers?.length < MAX_PLAYERS_PER_TEAM || _awayTeamPlayers?.length < MAX_PLAYERS_PER_TEAM) && !game?.currentMatchQuater) {
      showRoster = true;
    }
  
    navigate(`${routeConstant.SCORE_GAME_PAGE}/${seasonId}/${game?._id}`, { replace: true, state: { showRosterPage: showRoster } });
  }

  const handleRestartGame = async() => {
    const data = {
      gameId: game?.apiGameId,
    }
    setIsLoading(true)
    const response = await restartGame(data);
    if(restartLiveGame.fulfilled.match(response)){
      navigate(`${routeConstant.LIVE_GAME_PAGE}/${game._id}`);
    }
    setIsLoading(false);
  }

  const gameButtons = useMemo(() => {
    return getCurrentGameStatus(game?.matchStartDatetime, game?.matchEndDatetime, game?.powerUpFlag);
  }, [game?.powerUpFlag, game?.matchEndDatetime, game?.matchEndDatetime]);

  return (
    <div className={`${styles.dataRow}`}>
      {/* Opponent-Team Details/ Away Team */}
      <div className={styles.detailCell}>
        <div className={styles.teams}>

          {/* FOR DEMO COMMENTED PART (Remove the matchtitle part when the game is not a demo)*/}
          {/* <span className={styles.vs}>V/S</span> */}
          {/* <figure className={styles.team_icon}>
            <img src={game?.awayTeamImage || Warriors} alt="away team" />
          </figure> */}
          {/* <span className={styles.opponent_team_name}>{game?.awayTeamName}</span> */}
          <span className={styles.opponent_team_name}>{game?.matchTitle}</span>
        </div>
        
        {/* Action Button */}
        {showMoreButton && (
          <button className={styles.action_button_container} onClick={handleClick}>
            <MoreVert />
          </button>
        )}
      </div>


      {/* Time */}
      <div className={`${styles.detailCell} ${styles.time_div}`}>
        <div className={styles.date_and_time_container}>
          {/* Date */}
          <span className={styles.date_and_time}>{formattedDate}</span>
          {/* Time */}
          <span className={styles.date_and_time}>{formattedTime} (in CDT)</span>
        </div>
      </div>

      {/* Location/ Complex Name */}
      <div className={`${styles.detailCell} ${styles.sportcomplex}`}>
        <span className={styles.location}>{game?.sportsComplexName}</span>

        {/* Live Game */}
        {((gameButtons?.some(button => button?.status === GAME_STATUS.ENDED) && !game?.isGameEnded) || (gameButtons?.some(button => button?.status === GAME_STATUS.LIVE) && !game?.isGameEnded)) && (
          <Chip
            label={"View Live"}
            color="success"
            size="small"
            onClick={handleLiveGame}
            sx={{ cursor: "pointer", gap: "2px" , padding: "0px 5px", fontSize: "11px" , textTransform: "uppercase", 
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              '@media (max-width: 1240px)': {
              fontSize: '10px', 
              padding: '0px 5px', 
              height: 22,
            }, 
            '@media (max-width: 992px)': {
                fontSize: '10px', 
                padding: '0px 5px', 
                height: 20,
              }, 
              '@media (max-width: 500px)': {
              fontSize: '11px', 
              padding: '0px 6px', 
              height: 24,
              gap: '2px'
            }, 
          }}
            icon={<span className={styles.live_game_animation} />}
          />
        )}

        {/* Ended Game */}
        {game?.isGameEnded && (
          <Chip
            label={"Game Ended"}
            color="error"
            size="small"
            onClick={handleLiveGame}
            sx={{ cursor: "pointer", gap: "2px" , padding: "0px 5px", fontSize: "11px" , textTransform: "uppercase", 
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              '@media (max-width: 1240px)': {
              fontSize: '10px', 
              padding: '0px 5px', 
              height: 22,
            }, 
            '@media (max-width: 992px)': {
                fontSize: '10px', 
                padding: '0px 5px', 
                height: 20,
              }, 
              '@media (max-width: 500px)': {
              fontSize: '11px', 
              padding: '0px 6px', 
              height: 24,
              gap: '2px'
            }, }}
            icon={<span className={styles.live_game_animation}/>}
          />
        )}

        {/* Upcoming Game */}
        {(gameButtons?.some(button => button?.status === GAME_STATUS.UPCOMING) && !game?.isGameEnded) && (
          <Chip
            label={"Upcoming"}
            color="warning"
            size="small"
            sx={{ cursor: "default", gap: "2px" , padding: "0px 5px", fontSize: "11px" , textTransform: "uppercase", 
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              '@media (max-width: 1240px)': {
                fontSize: '10px', 
                padding: '0px 5px', 
                height: 22,
              }, 
              '@media (max-width: 992px)': {
                fontSize: '10px', 
                padding: '0px 5px', 
                height: 20,
              }, 
              '@media (max-width: 500px)': {
              fontSize: '11px', 
              padding: '0px 6px', 
              height: 24,
              gap: '2px'
          }, }}
          />
        )}
      </div>

      {/*FOR DEMO */}

      {/* <Button variant="secondary" className={styles.power_up} style={{ display: 'flex', alignItems: 'center', gap: '10px' }} onClick={handlePowerUp} disabled={!(gameButtons?.some(button => (button?.status === GAME_STATUS.POWERED_UP || button?.status === GAME_STATUS.POWER_UP)))}>
        <span className={styles.deployButton}>{(gameButtons?.some(button => button?.status === GAME_STATUS.POWERED_UP) || game?.isGameEnded) ? 'Powered Up' : `Power Up`}</span>
        <img src={Powerup} alt="Power Up" className={styles.power_up_icon} />
      </Button> */}

      <ViewMatchPopover anchorEl={anchorEl} onClose={handleClose} handleScoreGame={handleScoreGame} game={game} handleRestartGame={handleRestartGame} isLoading={isLoading} />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  restartGame: (data) => dispatch(restartLiveGame(data)),
})

export default connect(null, mapDispatchToProps)(MatchRow);
